import { injectable } from 'inversify';
import at from 'lodash/at';

import { FileInputValue } from '@vk-hr-tek/ui/input';

const PREFIX = '_attribute_';

interface FileAttribute {
  id: string;
  title: string;
}

interface GetFileListProps {
  files: FileAttribute[];
  initialAttributes: Record<string, string | FileInputValue | FileInputValue[]>;
  prefix: string;
}

injectable();
export class EventsMetaStructureService {
  getFileList({ files, initialAttributes, prefix }: GetFileListProps) {
    return files.reduce(
      (acc: (FileAttribute & { img: string })[], currentFile) => {
        const [value] = at(
          initialAttributes,
          `${prefix}${PREFIX}${currentFile.id}`,
        );

        if (Array.isArray(value)) {
          const urls = value.map(({ source }, index) => ({
            id: `${currentFile.id}${source as string}`,
            title: `${currentFile.title} ${index + 1}`,
            img: source as string,
          }));

          acc = [...acc, ...urls];
        } else if (value) {
          const { source } = value as FileInputValue;
          acc.push({
            ...currentFile,
            img: source as string,
          });
        }

        return acc;
      },
      [],
    );
  }
}
